
import { Vue, Component } from 'vue-property-decorator'

import { collectInit, PAGE_NAME_B } from '@/utils/common'
import LOGO from '@/utils/share/src/logo'
import useragent from '@finance/useragent'
// import { domain } from '@finance/domain'

@Component({
  name: 'Invite',
  components: {},
})
export default class Invite extends Vue {
  get videoUrl() {
    // return `${domain.feideeAct}/cab-ads-video/index.html#/`
    return 'https://yunrests2.feidee.cn/public-vue/cab-ads-video/index.html#/'
  }
  get jumpAppUrl() {
    return `https://t.feidee.com/financeWeb?url=${encodeURIComponent(this.videoUrl)}`
  }
  // 判断是否微信环境
  get isWeChat() {
    const ua = window.navigator.userAgent.toLowerCase()
    if (/MicroMessenger/i.test(ua)) {
      return true
    } else {
      return false
    }
  }

  appId = 'wx1cb7cd058987c8de'
  downloadUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.mymoney'
  showGuide = false

  handleLaunchFn() {
    console.log('wx-open-launch-app ok!')
    setTimeout(() => {
      this.$Collect.trackEvent(`${PAGE_NAME_B}_打开随手记`)
    }, 1500)
  }
  handleErrorFn(e: any) {
    console.warn('wx-open-launch-app error v2:', e)
    setTimeout(() => {
      this.$Collect.trackEvent(`${PAGE_NAME_B}_打开随手记`)
    }, 1500)
    if (e && e.detail && useragent.isIOS) {
      window.location.href = `https://t.feidee.cn/fdmymoney/financeWeb?url=${encodeURIComponent(this.videoUrl)}`
    } else {
      this.showGuide = true
    }
  }
  handleOpenApp() {
    this.$Collect.trackEvent(`${PAGE_NAME_B}_打开随手记`)
    window.location.href = this.jumpAppUrl
  }
  handleDownloadApp() {
    this.$Collect.trackEvent(`${PAGE_NAME_B}_下载随手记`)
    window.location.href = this.downloadUrl
  }
  shareConfig() {
    window.wx.ready(() => {
      const config = {
        title: '打开随手记',
        desc: '随手记记账更轻松！', // 分享描述
        link: window.location.href,
        imgUrl: LOGO,
      }

      // 分享到朋友圈
      window.wx.onMenuShareTimeline({
        ...config,
        success() {}
      })
      // 分享给朋友
      window.wx.onMenuShareAppMessage({
        ...config,
        success() {}
      })
      // 分享到QQ
      window.wx.onMenuShareQQ({
        ...config,
        success() {}
      })
      // qzone
      window.wx.onMenuShareQZone({
        ...config,
        success() {}
      })
    })
  }
  async mounted() {
    this.shareConfig()
    await collectInit({ pageName: PAGE_NAME_B })
    this.$Collect.trackView(`${PAGE_NAME_B}_浏览`)
  }
}
